<script setup lang="ts">
import { DateTime } from 'luxon'

import {
  type Pet,
  PetFertilityEnum,
  PetGenderEnum,
  PetSizeEnum,
  PetTypeEnum,
} from '~/layers/forms/models'

interface Props {
  model: Pet
}
const props = defineProps<Props>()

const data = computed(() => [
  { label: 'Número de microchip', value: props.model.microchip },
  {
    label: 'Fecha de nacimiento',
    value: props.model.birthDate ? DateTime.fromJSDate(props.model.birthDate).toISODate() : null,
  },
  { label: 'Raza', value: props.model.breed?.name },
  { label: 'Color', value: props.model.color?.name },
  { label: 'Duración', value: props.model.size ? PetSizeEnum[props.model.size].label : null },
  {
    label: 'Aparato reproductivo',
    value: props.model.fertility ? PetFertilityEnum[props.model.fertility].label : null,
  },
  { label: 'Sexo', value: props.model.gender ? PetGenderEnum[props.model.gender].label : null },
])
</script>
<template>
  <FormsGlobalResume
    :type="model.petType ? PetTypeEnum[model.petType].label : null"
    :name="model?.name"
    :data
    hint-text="Información de la mascota"
  />
</template>
